<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <div class="tab-actions">
      <button
        buttonTheme="primary"
        buttonType="regular"
        type="button"
        (click)="createOpen.set(true)"
      >
        {{ dictionary.get('CreateTicket') }}
      </button>
    </div>

    <app-api-table
      #ticketsTable
      endpoint="/tickets/tables/user"
      [name]="name"
      [extraBody]="allTimeRange"
      [hasIndexCol]="true"
      [hasChartView]="false"
      [onRowClick]="openTicket"
    />

    <app-create-ticket-modal
      [isOpen]="createOpen()"
      (closed)="createOpen.set(false)"
      (created)="ticketCreated($event)"
    />

    <app-ticket-conversation-modal
      [isOpen]="!!selectedTicket()"
      [ticketNumber]="selectedTicket()"
      (closed)="selectedTicket.set(null)"
      (changed)="refresh()"
    />
  }
</app-tab-layout>
